<h2 mat-dialog-title>{{ 'dialog.charges.save-template' | translate }}</h2>

<mat-dialog-content>
  <form [formGroup]="form" fxLayout="column" fxLayoutGap="1rem">
    <mat-form-field appearance="outline">
      <mat-label>{{ 'common.name' | translate }}</mat-label>
      <input matInput formControlName="name" />
      <mat-error *ngIf="form.controls.name.hasError('required')">
        {{ 'common.field-required' | translate }}
      </mat-error>
    </mat-form-field>

    <div *ngIf="facilityName">
      <strong>{{ 'common.facility' | translate }}:</strong> {{ facilityName }}
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{ 'common.cancel' | translate }}</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="form.invalid || saving">
    {{ 'common.save' | translate }}
  </button>
</mat-dialog-actions>
